var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrapi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "strapi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,88.7466264 C0,46.911034 0,25.9932981 12.9965887,12.9965887 C25.9932981,0 46.911034,0 88.7466264,0 L167.253736,0 C209.089208,0 230.00634,0 243.00317,12.9965887 C256,25.9932981 256,46.911034 256,88.7466264 L256,167.253736 C256,209.089208 256,230.00634 243.00317,243.00317 C230.00634,256 209.089208,256 167.253736,256 L88.7466264,256 C46.911034,256 25.9932981,256 12.9965887,243.00317 C0,230.00634 0,209.089208 0,167.253736 L0,88.7466264 Z",
    fill: "#4945FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.64,77.6532528 L90.4527698,77.6532528 L90.4527698,121.6 L134.4,121.6 L134.4,165.546264 L178.346264,165.546264 L178.346264,79.36 C178.346264,78.4173887 177.581887,77.6532528 176.64,77.6532528 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 132.692528,
    y: 121.6,
    width: 1.70666264,
    height: 1.70666264
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4527698,121.6 L132.692528,121.6 C133.635623,121.6 134.4,122.364377 134.4,123.306264 L134.4,165.546264 L92.159517,165.546264 C91.2169057,165.546264 90.4527698,164.783094 90.4527698,163.84 L90.4527698,121.6 Z",
    fill: "#9593FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4,165.546264 L178.346264,165.546264 L135.856302,208.036226 C135.318943,208.573585 134.4,208.193208 134.4,207.43366 L134.4,165.546264 Z",
    fill: "#9593FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4526491,121.6 L48.5660981,121.6 C47.8059472,121.6 47.4252075,120.680815 47.9626868,120.143215 L90.4526491,77.6532528 L90.4526491,121.6 Z",
    fill: "#9593FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrapi);
export default __webpack_public_path__ + "static/media/strapi.9ab38273f21de27e881d97ea7a94b501.svg";
export { ForwardRef as ReactComponent };